<template>
  <div v-if="avatar !== false" class="hello text-center">
    <div><vs-avatar size="150px" :src="avatar"/></div>
    <vs-button color="primary" type="border"  @click="handleClick">Изменить изображение</vs-button>

    <vs-popup
      title="Изменить изображение"
      :active.sync="crop_image"
    >
     <picture-input
        v-if="crop_image && new_image == null"
        ref="pictureInput"
        @change="onChange"
        width="179"
        height="179"
        margin="16"
        accept="image/jpeg,image/png"
        size="10"
        buttonClass="btn"
        :customStrings="{
          select: 'Выбрать фото',
          change: 'Изменить фото',
          upload: '<p>Ваше устройство не поддерживается</p>',
          drag: 'Загрузить'
        }">
      >
      </picture-input>
      <div v-if="new_image" >
        <Cropper
          ref="cropper"
          class="upload-example-cropper"
          :stencil-props="{
            minAspectRatio: 8/8,
            maxAspectRatio: 8/8
          }"
          :src="new_image"
        />
        <div class="mt-4">
          <vs-button color="primary" type="filled" @click="cropImage">Сохранить</vs-button>
          <vs-button color="primary" type="border" class="ml-3" @click="new_image=null">Выбрать другое</vs-button>
        </div>
      </div>
    </vs-popup>
  </div>
</template>
<script>
import ApiService from '@/common/api.service'

import PictureInput from 'vue-picture-input'
import { Cropper } from 'vue-advanced-cropper'

export default {
  components: { PictureInput, Cropper },
  props: ['branch_id'],
  data() {
    return {
      avatar: false,
      crop_image: false,
      new_image: null
    }
  },
  methods: {
    handleClick() {
      this.crop_image = true
      this.$km_track('Profile', 'Click', 'ChangePicture')
    },
    onChange(image) {
      this.new_image = image
    },
    async cropImage() {
      const result = this.$refs.cropper.getResult()
      this.avatar = result.canvas.toDataURL('image/jpeg')
      this.crop_image = false
      this.new_image = null
      const name = Math.random().toString(36).substring(7)
      const { canvas } = this.$refs.cropper.getResult()
      if (canvas) {
        const form = new FormData()
        canvas.toBlob(blob => {
          const avatar_file = new File([blob], `${name}.jpeg`, { type: blob.type })
          form.append('avatar', avatar_file)
          ApiService.put(`/branch_page/avatar/${this.branch_id}`, form)
            .then(response => {
            })
        }, 'image/jpeg')
      }
    },
    async update_avatar() {
      const { data } = await ApiService.get(`/branch_page/avatar/${this.branch_id}`)
      if (data) {
        if (data.avatar != null) {
          this.avatar = data.avatar
        } else {
          this.avatar = ''
        }
      }
    }
  },
  created() {
    if (this.branch_id) {
      this.update_avatar()
    }
  },
  watch: {
    branch_id: function(newVal, oldVal) { // watch it
      this.update_avatar()
    }
  }
}
</script>
